import React, { useMemo } from 'react';
import {
  Col, Form, FormItemProps, Input, Row, Select,
} from 'antd';
import { enumToOptionsArray } from '../../../../utils';
import { UserRoleDisplay } from '../../../../enums/user';
import { UserCreateParams } from '../../../../hooks/api/users';

// const validationRules = createRulesForAntd(validationUserEdit);

function UserFormItems({ data }: { data?: Partial<UserCreateParams> }) {
  const formItems: (FormItemProps & { element: React.ReactNode, colSpan?: number })[] = useMemo(() => [
    /* {
      name: 'firstName',
      label: 'First Name',
      element: <Input placeholder="Enter" disabled />,
    },
    {
      name: 'dateOfBirth',
      label: 'Date of birth',
      rules: [{ required: true }],
      element: <DatePicker format={dateFormat} style={{ width: '100%' }} />,
    },
    {
      name: 'phone',
      label: 'Phone',
      element: <AlternativePhoneInput />,
    },
    */
    {
      name: 'email',
      label: 'Email',
      rules: [{ required: true }],
      element: <Input placeholder="Enter" />,
    },
    {
      name: 'role',
      label: 'Role',
      rules: [{ required: true }],
      element: <Select
        placeholder="Select"
        options={enumToOptionsArray(UserRoleDisplay)}
        // Only force-disable for root; otherwise inherit Form `disabled` (e.g. Mitarbeiter read-only)
        disabled={data?.role === 'root' || undefined}
      />,
    },
    {
      name: 'status',
      label: 'status',
      rules: [{ required: false }],
      style: { display: 'none' },
      element: <Input />,
    },
  ], [data]);

  return (
    <div>
      <Row gutter={12}>
        {formItems.map(({
          element, colSpan, name, rules, ...formItemProps
        }) => (
          <Col key={name} span={colSpan || 12}>
            <Form.Item name={name} {...formItemProps} rules={[...(rules || [])]}>
              {/* validationRules */}
              {element}
            </Form.Item>
          </Col>
        ))}
        {/* <Col span={12} /> */}
      </Row>
    </div>
  );
}

export default UserFormItems;
